import React from 'react';
import usePlanningDialog from '../hooks/usePlanningDialog';

export default function PlanningDeleteDialog({ event, deleting, onCancel, onConfirm }) {
  const dialogRef = usePlanningDialog(onCancel, Boolean(event));
  if (!event) return null;
  const hasExternalEvent = Boolean(event.externalEventId);
  return (
    <div className="planning-modal-backdrop" onMouseDown={(mouseEvent) => mouseEvent.target === mouseEvent.currentTarget && onCancel()}>
      <section ref={dialogRef} className="planning-delete-dialog" role="dialog" aria-modal="true" aria-labelledby="planning-delete-title" tabIndex="-1">
        <header>
          <strong id="planning-delete-title">Supprimer « {event.title} »</strong>
        </header>
        <p>{hasExternalEvent ? 'Cet élément est lié à un événement CalDAV. Choisissez précisément la portée de la suppression.' : 'Supprimer cet élément du planning ERP ?'}</p>
        <footer>
          <button className="basic-button" disabled={deleting} onClick={onCancel}>Annuler</button>
          <button className="basic-button" disabled={deleting} onClick={() => onConfirm(false)}>Retirer uniquement de l’ERP</button>
          {hasExternalEvent && <button className="basic-button basic-button--danger" disabled={deleting} onClick={() => onConfirm(true)}>Supprimer partout</button>}
        </footer>
      </section>
    </div>
  );
}
